import React from 'react';
import { useTranslation } from 'react-i18next';
import './FileUploadField.css';

const FileUploadField = ({
    label,
    value,
    onChange,
    uploading,
    type = 'square', // 'circle', 'rectangle', 'square'
    accept = 'image/*',
    hint,
    multiple = false,
    className = ''
}) => {
    const { t } = useTranslation();
    const [isDragging, setIsDragging] = React.useState(false);
    const id = React.useId();

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!uploading) setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        if (uploading) return;

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // Simulate an event object for the existing onChange handler
            const files = multiple ? Array.from(e.dataTransfer.files) : [e.dataTransfer.files[0]];
            onChange({
                target: {
                    files
                }
            });
        }
    };

    return (
        <div className={`file-upload-field ${type} ${isDragging ? 'dragging' : ''} ${className}`}>
            {label && <label className="field-label">{label}</label>}

            <div className="upload-container">
                <input
                    type="file"
                    id={id}
                    accept={accept}
                    multiple={multiple}
                    onChange={onChange}
                    onClick={(e) => { e.target.value = null; }}
                    disabled={uploading}
                    className="file-input"
                />

                <label
                    htmlFor={id}
                    className={`upload-trigger ${value ? 'has-value' : ''} ${uploading ? 'uploading' : ''} ${isDragging ? 'drag-active' : ''}`}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                >
                    {value ? (
                        <div className="preview-wrapper">
                            <img src={value} alt="Preview" className="upload-preview" />
                            <div className="upload-overlay">
                                <span>{uploading ? t('loading') : (isDragging ? t('drop_to_upload') : t('change_photo'))}</span>
                            </div>
                        </div>
                    ) : (
                        <div className="placeholder-wrapper">
                            <div className="upload-icon">
                                {uploading ? (
                                    <div className="spinner"></div>
                                ) : (
                                    <span className="plus">{isDragging ? '↓' : '+'}</span>
                                )}
                            </div>
                            <span className="placeholder-text">
                                {uploading ? t('loading') : (isDragging ? t('drop_to_upload') : t('upload_photo'))}
                            </span>
                        </div>
                    )}
                </label>
            </div>

            {hint && <small className="field-hint">{hint}</small>}
        </div>
    );
};

export default FileUploadField;
